<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <!-- <button-add value="生成报表1" @click="reportGenerate" disabled v-if="finished"/> -->
        <el-button v-if="finished" type="info" plain disabled class="el-icon-plus margin-right-4">生成报表</el-button>
        <button-add value="生成报表" @click="reportGenerate" v-else/>
      </div>
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        download="download.xls"
        value="导出"/>
    </div>

    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"></table-main>

    <el-dialog
      title="修改备注"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
     <el-input v-model="formData.memo" size="small" style="width: 280px" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="cancel">取 消</el-button>
        <el-button type="primary" size="small" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Material";
import { bus } from "../../../utils/bus";
import ButtonAdd from "../../../components/common/buttons/button-add";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb,
    ButtonCancel,
    ButtonConfirm,
    TextTitle
  },
  name: "inventory-report",
  data() {
    return {
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "物资盘点"
        }
      ],
      tableHead: [
        {
          prop: "taskName",
          label: "盘点任务"
        },
        {
          prop: "materialsName",
          label: "物资名称"
        },
        {
          prop: "applyNumber",
          label: "应盘数量"
        },
        {
          prop: "normalNumber",
          label: "正常数量"
        },
        {
          prop: "lostNumber",
          label: "遗失数量"
        },
        {
          prop: "abnormalNumber",
          label: "异常数量"
        },
        {
          prop: "scrapNumber",
          label: "报废数量"
        },
        {
          prop: "checkNumber",
          label: "数量核对"
        }
      ],
      tableData: [],
      mainTitle: "查看盘点报表",
      subheading: "",
      exportUrl: "",
      requestData: {
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      timevalue: [],
      categoryTypeList: [],
      dialogVisible: false,
      countListCode: "",
      formData: {},
      finished: false
    };
  },
  created() {
    // this.getPage();
    this.getFinished();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportCountReport}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`;
    },

    getFinished() {
      this.$axios
        .get(`${api.getCountTaskByCode}/${this.$route.params.id}`, {})
        .then(res => {
          this.finished = res.data.data.finished;
          if (res.data.data.finished) {
            this.getPage();
          } else {
          }
        })
        .catch(errorHandler("查询失败"));
    },

    getPage() {
      this.$axios
        .post(api.getCountReportPage, this.requestData)
        .then(res => {
          console.log(res);
          let list = res.data.data.list;
          list.map(v => {
            if (v.counted) {
              v.countedStatus = "已盘点";
            } else {
              v.countedStatus = "未盘点";
            }
            if (v.materialsStatus === "1") {
              v.materialsTextStatus = "正常";
            } else if (v.materialsStatus === "2") {
              v.materialsTextStatus = "遗失";
            } else if (v.materialsStatus === "3") {
              v.materialsTextStatus = "异常";
            } else if (v.materialsStatus === "4") {
              v.materialsTextStatus = "报废";
            } else {
              v.materialsTextStatus = "--";
            }
          });
          this.total = res.data.data.total;
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    getCountListByCode() {
      this.$axios
        .get(`${api.getCountListByCode}/${this.countListCode}`, {})
        .then(res => {
          this.formData = res.data.data;
        })
        .catch(errorHandler("查询失败"));
    },
    search() {},
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    goToModifyPage(code) {
      this.dialogVisible = true;
      this.countListCode = code;
      this.getCountListByCode();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm() {
      this.$axios
        .post(api.updateCountList, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
          }
        })
        .catch(errorHandler("修改失败"));
      this.dialogVisible = false;
    },
    reportGenerate() {
      this.$axios
        .get(`${api.getCountReport}/${this.$route.params.id}`, {})
        .then(res => {
          this.tableData = res.data.data;
          nSuccess("生成报表成功");
        })
        .catch(errorHandler("生成失败"));
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialInventory/InventoryReport.vue